import { changetheme } from '@/app/store/layout/layout-action'
import { CommonModule, DOCUMENT } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  EventEmitter,
  Inject,
  Output,
  inject,
  type TemplateRef,
} from '@angular/core'
import {
  NgbDropdownModule,
  NgbOffcanvas,
  NgbOffcanvasModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { SimplebarAngularModule } from 'simplebar-angular'
import { getLayoutColor } from '../../store/layout/layout-selector'
import { logout } from '@/app/store/authentication/authentication.actions'
import { Router, RouterLink } from '@angular/router'
import { activityStreamData, appsData, notificationsData } from './data'
import { CommonService } from '@/app/core/services/common.service'
import { TOPMENU, type TopMenuItem } from '../../common/top-menu-meta'
import { HasPermissionDirective } from '@/app/directive/has-permission-directive.directive'

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    NgbDropdownModule,
    SimplebarAngularModule,
    NgbOffcanvasModule,
    RouterLink,
    CommonModule,
    NgbTooltipModule,
    HasPermissionDirective
  ],
  templateUrl: './topbar.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TopbarComponent {
  element: any
  topMenuItems: TopMenuItem[] = []
  router = inject(Router)
  store = inject(Store)
  offcanvasService = inject(NgbOffcanvas)
  commonService = inject(CommonService)

  notificationList = notificationsData
  appsList = appsData
  activityList = activityStreamData
  public userName: any;

  constructor(@Inject(DOCUMENT) private document: any) { }
  @Output() settingsButtonClicked = new EventEmitter()
  @Output() mobileMenuButtonClicked = new EventEmitter()

  ngOnInit(): void {
    this.userName = `${localStorage.getItem('first_name') || ''} ${localStorage.getItem('last_name') || ''}`.trim();
    this.element = document.documentElement
    this.topMenuItems = TOPMENU;
  }

  handleFormSubmit(event: Event, value: string) {
    event.preventDefault();
    this.onSearch(value);
  }

  onSearch(value: any) {
    this.router.navigate(['/project-detail'], { queryParams: { search: value }, queryParamsHandling: 'merge' });
  }

  settingMenu() {
    this.settingsButtonClicked.emit()
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu() {
    // document.getElementById('topnav-hamburger-icon')?.classList.toggle('open');
    this.mobileMenuButtonClicked.emit()
  }

  // Change Theme
  changeTheme() {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme');
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', newTheme);
    this.store.dispatch(changetheme({ color: newTheme }));
    document.documentElement.setAttribute('data-bs-theme', newTheme);
  }

  open(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {
      position: 'end',
      panelClass: 'border-0 width-auto',
    })
  }

  logout() {
    this.commonService.logoutAction()
    // this.store.dispatch(logout())
  }

  getFileExtensionIcon(file: any) {
    const dotIndex = file.lastIndexOf('.')
    const extension = file.slice(dotIndex + 1)
    if (extension == 'docs') {
      return 'bxs-file-doc'
    } else if (extension == 'zip') {
      return 'bxs-file-archive'
    } else {
      return 'bxl-figma '
    }
  }

  getActivityIcon(type: string) {
    if (type == 'task') {
      return 'iconamoon:folder-check-duotone'
    } else if (type == 'design') {
      return 'iconamoon:check-circle-1-duotone'
    } else {
      return 'iconamoon:certificate-badge-duotone'
    }
  }
}
